import React, { useState, useEffect } from 'react'
import { Dialog, DialogHeader, DialogBody } from "@material-tailwind/react";
import { useSelector } from 'react-redux';
import { registerReferalCode, getReferalHistory } from '../util/refer-api';
import { DocumentDuplicateIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import imaginaryGif from '../assets/imgs/imaginary.gif'

export default function ReferalCard({setShowReferalCard, showReferalCard}) {
  const wallet = useSelector(state => state.wallet);
  const { t } = useTranslation();
  const [referalCode, setReferalCode] = useState("");
  const [referalUsers, setReferalUsers] = useState(0);
  const [referalSats, setReferalSats] = useState(0);

  useEffect(() => {
    const handleReferal = async () => {
      const data = await registerReferalCode(wallet.nostrPaymentAddress);
      setReferalCode(data.data.code);

      const history = await getReferalHistory(wallet.nostrPaymentAddress);
      setReferalUsers(history.data[0].totalCount);
      setReferalSats(history.data[0].totalSats ? history.data[0].totalSats : 0);
    }
    handleReferal();
  }, [wallet]);

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value).then(
      () => {
        // Successfully copied to clipboard
        toast.success(t('Copied!'))
      },
      (err) => {
        // Failed to copy to clipboard
        console.error('Could not copy address: ', err);
      }
    );
  }

  return (
    <Dialog
      open={showReferalCard}
      size={"sm"}
      className="bg-black"
    >
      <DialogBody>
        <div className='flex flex-col md:p-3 p-1 gap-4 relative'>
          <div className="absolute top-0 right-0">
            <XMarkIcon className="h-5 w-5 cursor-pointer text-white" onClick={() => {setShowReferalCard(false)}} />
          </div>
          <div className="flex flex-row items-center gap-2">
            <div className="text-white sm:text-[20px] text-[16px] font-bold">
              {t("Refer Header")}
            </div>
            <img src={imaginaryGif} className="w-[60px] h-[60px]"/>
          </div>
          
          <div className="text-white sm:text-[16px] text-[14px]">
            {t("Refer Description")}
          </div>
          <div className="flex flex-row justify-between border-[1px] border-gray-500 rounded-md bg-background1 p-2">
            <div className="text-white sm:text-[16px] text-[12px]">https://bitcoinuniverse.io/earn/{referalCode}</div>
            <DocumentDuplicateIcon className="h-5 w-5 cursor-pointer text-primary hover:text-primary-hover" onClick={() => {handleCopy(`https://bitcoinuniverse.io/earn/${referalCode}`)}} />
          </div>
          <div className="flex sm:flex-row flex-col justify-between">
            <div className="flex flex-row text-white sm:text-[16px] text-[14px] gap-2">
              <div>{t("Referrals")}:</div>
              <div>{referalUsers} {t("users")}</div>
            </div>
            <div className="flex flex-row text-white sm:text-[16px] text-[14px] gap-2">
              <div>{t("Sats earned")}:</div>
              <div>{referalSats} {t("sats")}</div>
            </div>
          </div>
        </div>
      </DialogBody>
    </Dialog>
  )
}
